var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
import * as Types from '../../types';
import { prism } from './lib/prism.cls';
import * as prismStoreExtensions from './provider/candle-history';
var state = __assign({}, prismStoreExtensions.stateExt);
var actions = __assign({}, prismStoreExtensions.actionsExt);
var mutations = __assign({}, prismStoreExtensions.mutationsExt);
var getters = __assign({}, prismStoreExtensions.gettersExt);
var prismStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var _store;
var intervalValue = null;
export var prismMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[prism.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(prism.STORE_MODULE_NAME, prismStore);
            }
            catch (error) { }
        }
    },
    methods: __assign(__assign({}, mapActions({
        _runUserOtpCheck: Const.RUN_USER_OTP_CHECK,
        _runGetCvlDataApi: Const.RUN_GET_CVL_DATA_API,
        _runGetUserPanAttemptList: Const.RUN_GET_USER_PAN_ATTEMPT_LIST,
        _runUpdateUserPanAttempt: Const.RUN_UPDATE_USER_PAN_ATTEMPTS,
        _runDetailUserPanAttempt: Const.RUN_DETAIL_USER_PAN_ATTEMPTS,
        _runDownloadPaymentSheet: Const.RUN_DOWNLOAD_PAYMENT_SHEET,
        _runGetPanData: Const.RUN_GET_PAN_DATA,
        _runBackStageTicket: Const.RUN_BACKSTAGE_TICKET,
        _runUploadMarginPledgeIsinDoc: Const.RUN_MARGIN_PLEDGE_ISIN_DOC,
        _runGetBankDetailSheet: Const.RUN_GET_BANK_DETAIL_SHEET,
        //-------------------------------------------bpo User--------------------------------------------
        _runBPOUserListing: Const.RUN_BPO_USER_LISTING,
        _runGetBPOReportFinLedger: Const.RUN_BPO_USER_REPORT_FINANCIAL_LEDGER,
        _runGetBPOReportHoldings: Const.RUN_BPO_USER_REPORT_HOLDINGS,
        _runGetBPOReportPNL: Const.RUN_BPO_USER_REPORT_PNL,
        _runGetBPOReportContractNotes: Const.RUN_BPO_USER_REPORT_CONTRACT_NOTES,
        _runGetBPOReportTradeCon: Const.RUN_BPO_USER_REPORT_TRADE_CON,
        //-------------------------------------------admin User--------------------------------------------
        _runLeadUserListing: Const.RUN_LEAD_USER_LISTING,
        _runadminUserListing: Const.RUN_ADMIN_USER_LISTING,
        _runViewAdminUserDetail: Const.RUN_VIEW_ADMIN_USER_DETAIL,
        _runAdminAcceptRejectDocument: Const.RUN_ADMIN_ACCEPT_REJECT_DOCUMENT,
        _runAdminAcceptUser: Const.RUN_ADMIN_ACCEPT_USER,
        _runAdminHoldUser: Const.RUN_ADMIN_HOLD_USER,
        _runAcceptUserKyc: Const.RUN_ACCEPT_USER_KYC,
        _runAcceptUserKycManually: Const.RUN_ACCEPT_USER_KYC_MANUALLY,
        _runDashboardApi: Const.RUN_DASHBOARD_API,
        _runEnableEsignDoc: Const.RUN_ENABLE_ESIGN_DOC,
        _runPANListing: Const.RUN_PAN_NUMBER_LISTING,
        _runPANFetchDigitap: Const.RUN_PAN_DETAILS_DIGITAP,
        _runCVLStatusListing: Const.RUN_CVL_STATUS_LISTING,
        _runCVLResponseListing: Const.RUN_CVL_RESPONSE_LISTING,
        //-------------------------------------------add--------------------------------------------
        _runAddData: Const.RUN_ADD_DATA,
        //-------------------------------------------listing----------------------------------------
        _runGetListingData: Const.RUN_GET_LISTING_DATA,
        //-------------------------------------------view-------------------------------------------
        _runViewSupportDetail: Const.RUN_VIEW_SUPPORT_DETAIL,
        //-------------------------------------------dropdown---------------------------------------
        _runGetSupportReasonList: Const.RUN_GET_SUPPORT_REASON_LIST,
        //-------------------------------------------Admin Approve Ticket----------------------------
        _runAdminApprovedTicket: Const.RUN_ADMIN_APPROVE_TICKET,
        _runAdminApprovedTicketStep2: Const.RUN_ADMIN_APPROVE_TICKET_STEP2,
        _runUserXmlDownload: Const.RUN_USER_XML_DOWNLOAD,
        //-------------------------------------------Admin Reject Ticket----------------------------
        _runAdminAcceptRejectTicket: Const.RUN_ADMIN_ACCEPT_REJECT_TICKET,
        _runAdminCompressPdf: Const.RUN_ADMIN_COMPRESS_PDF,
        _runTicketStatusFunction: Const.RUN_TICKET_STATUS_FUNCTION,
        _runCancelTicket: Const.RUN_CANCEL_TICKET,
        _runResignDocument: Const.RUN_RESIGN_DOCUMENT,
        _runResignUserKyc: Const.RUN_RESIGN_USER_KYC,
        _runGetRisingUpdateNeedSynced: Const.RUN_GET_RISING_UPDATE_SYNCED,
        //-------------------------------------------Missing Pic----------------------------------
        _runMissingPicTicket: Const.RUN_MISSING_PIC_TICKET,
        _runGetSquadDataForDownload: Const.RUN_GET_SQUAD_DATA_DOWNLOAD,
        _runGetListUserNeedSynced: Const.RUN_GET_LIST_USER_SYNCED,
        _runPanApi: Const.RUN_PAN_API,
        _runChangeUserStep: Const.RUN_CHANGE_USER_STEP,
        _runNewRegisterationsView: Const.RUN_NEW_REGISTERATIONS_VIEW,
        _runadminUserVerifyFinal: Const.RUN_USER_VERIFY_FINAL,
        _runSwitchNonKra: Const.RUN_SWITCH_NON_KRA,
        _runClientInfoEdit: Const.RUN_CLIENT_INFO_EDIT,
        _runRmUploadDocuments: Const.RUN_RM_UPLOAD_DOCUMENT,
        _runRmVerifyUser: Const.RUN_RM_VERIFY_USER,
        _runRmAddComment: Const.RUN_RM_ADD_COMMENT,
        _runRmCategorisationUser: Const.RUN_CATEGORISATION_USER,
        _runCategorisationUserDetail: Const.RUN_CATEGORISATION_USER_DETAIL,
        _runDematPendingListing: Const.RUN_DEMAT_PENDING_LIST,
        _runapiAdminAssignTicket: Const.RUN_ADMIN_ASSIGN_TICKET,
        _runEditProfileImage: Const.RUN_EDIT_PROFILE_IMAGE,
        _runresetPassword: Const.RUN_RESET_PASSWORD,
        _runresetQuesAns: Const.RUN_RESET_QUES_ANS,
        _runChangeNestUser: Const.RUN_CHANGE_NEST_USER,
        _runAddDematDetails: Const.RUN_ADD_DEMAT_DETAILS,
        _runFetchKraKyc: Const.RUN_FETCH_KRA_KYC,
        _runGetExchangeData: Const.RUN_EXCHANGE_DATA,
        _runListUserRisingSync: Const.RUN_LIST_USER_RISING_DATA,
        _runStepSkipApi: Const.RUN_STEP_SKIP_API,
        _runIsUserVerify: Const.RUN_IS_USER_VERIFY,
        _runOpenCash: Const.RUN_OPEN_CASH,
        _runRejectUserDocs: Const.RUN_REJECT_USER_DOCS,
        _runUserUpdateClientCode: Const.RUN_USER_UPDATE_CLIENT_CODE,
        _runAdminPayin: Const.RUN_ADMIN_PAYIN,
        _runAdminPayout: Const.RUN_ADMIN_PAYOUT,
        _runAdminPayoutList: Const.RUN_ADMIN_PAYOUT_LIST,
        _runUploadPayout: Const.RUN_UPLOAD_PAYOUT,
        _runMarkAsAtomPayin: Const.RUN_CREDITED_BY_ATOM,
        _runUploadAtomTransaction: Const.RUN_UPLOAD_ATOM_TRNS_FILE,
        _runUploadMfIsinDoc: Const.RUN_UPLOAD_MF_ISIN_DOC,
        _runStaggingRisingList: Const.RUN_STAGGING_RISING_LIST,
        _runStaggingRisingUpdate: Const.RUN_STAGGING_RISING_UPDATE,
        _runLockUnlockTransaction: Const.RUN_LOCK_UNLOCK_TRANSACTION,
        _runRisingReconcilationList: Const.RUN_RISING_RECONCILATION_LIST,
        _runDebitList: Const.RUN_DEBIT_LIST,
        _runAddClientCodeDebitList: Const.RUN_ADD_CLIENT_CODE_DEBIT_LIST,
        _runCancelPayout: Const.RUN_CANCEL_PAYOUT,
        _runGetLockUnlockTransData: Const.RUN_GET_LOCK_UNLOCK_DATA,
        _runeditTicket: Const.RUN_EDIT_TICKET,
        _runUploadDocument: Const.RUN_UPLOAD_DOCUMENT,
        _runUploadCvlDocument: Const.RUN_UPLOAD_CVL_DOCUMENT,
        _runGetCatList: Const.RUN_GET_CAT_LIST,
        _runCreateCategory: Const.RUN_CREATE_CATEGORY,
        _runCreateArticle: Const.RUN_CREATE_ARTICLE,
        _runGetArticleList: Const.RUN_GET_ARTICLE_LIST,
        _runGetArticleDetail: Const.RUN_GET_ARTICLE_DETAIL,
        _runGetCatDetail: Const.RUN_GET_CAT_DETAIL,
        _runChangePassword: Const.RUN_CHANGE_PASSWORD,
        _runCouponListing: Const.RUN_GET_COUPON_LISTING,
        _runCouponDocument: Const.RUN_COUPON_DOCUMENT,
        _runGetCouponCsvFile: Const.RUN_COUPON_CSV_FILE,
        _runCouponEmailSent: Const.RUN_COUPON_EMAIL_SENT,
        _runCreateAdmin: Const.RUN_CREATE_ADMIN,
        //--------------------------------------NOMINEE DATA-------------------------------
        _runGetUsersListForNominee: Const.RUN_GET_USERS_LIST_FOR_NOMINEE,
        _runGetNomineeDetail: Const.RUN_GET_NOMINEE_DETAIL,
        _runGetCvlResponse: Const.RUN_GET_CVL_RESPONSE,
        _runGetCvlStatus: Const.RUN_GET_CVL_STATUS,
        _runPushtoFTP: Const.RUN_PUSH_TO_FTP,
        //--------------------------------------API KEY-------------------------------
        _runGetApiKeyList: Const.RUN_GET_API_KEY_LIST,
        _runDisableApiKey: Const.RUN_DISABLE_API_KEY,
        _runGetadminReferredList: Const.RUN_GET_ADMIN_REFERRED_LIST,
        _rungetadminChartData: Const.RUN_GET_ADMIN_CHART_DATA,
        _runUploadAccountPayout: Const.RUN_UPLOAD_ACCOUNT_PAYOUT,
        _runUploadAccountStatusDoc: Const.RUN_UPLOAD_ACCOUNT_STATUS_DOC,
        _runTransferDataToSquadiq: Const.RUN_TRANSFER_DATA_TO_SQUADIQ,
        _runCreateUserSquadiq: Const.RUN_CREATE_USER_SQUADIQ,
        _runUserListForSquadiq: Const.RUN_USER_LIST_FOR_SQUADIQ,
        _runGetSquadDataForUpdateLead: Const.RUN_USER_UPDATE_FOR_SQUADIQ,
        _runRemoveUserFromHoldStage: Const.RUN_REMOVE_USER_FROM_HOLD_STAGE,
        _runDownloadExcelSheetOfUserDetail: Const.RUN_DOWNLOAD_EXCEL_SHEET_USER_DETAIL,
        _runKycUploadDocument: Const.RUN_KYC_UPLOAD_DOCUMENT,
        _runKycUserListing: Const.RUN_KYC_USER_LISTING,
        //--------------------------------------SUBSCRIPTION LIST-------------------------------
        _runSubscriptionList: Const.RUN_SUBSCRIPTION_LIST,
        _runSubscriptionDetail: Const.RUN_SUBSCRIPTION_DETAIL,
        //--------------------------------------CREATE TICKET----------------------------------
        _runCreateTicket: Const.RUN_CREATE_TICKET,
    })), { redirect: function (getPageName, getId, getParams, getVerifiedStatus) {
            var inputJson = {
                name: getPageName,
                query: { 'id': getId }
            };
            if (getParams != '' && getParams != null && getParams != undefined) {
                inputJson.query['userId'] = getParams;
            }
            if (getVerifiedStatus != '' && getVerifiedStatus != null && getVerifiedStatus != undefined) {
                inputJson.query['getVerifiedStatus'] = getVerifiedStatus;
            }
            var routeData = this.$router.resolve(inputJson);
            window.open(routeData.href, '_blank');
        }, SetCapitalname: function (getdocname) {
            if (getdocname) {
                var arr = getdocname.split(' ');
                for (var i = 0; i <= arr.length - 1; i++) {
                    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
                }
                arr = arr.join(" ");
                return arr;
            }
        }, clear_local_user_filter: function () {
            localStorage.removeItem('user_detail_view_filter');
        }, numberWithCommas: function (x) {
            if (x == undefined) {
                x = 0;
            }
            var negative = "";
            if (x < 0) {
                negative = '-';
            }
            x = parseFloat(x).toFixed(2);
            x = Math.abs(x);
            x = x.toString();
            var afterPoint = '';
            if (x.indexOf('.') > 0)
                afterPoint = x.substring(x.indexOf('.'), x.length);
            x = Math.floor(x);
            x = x.toString();
            var lastThree = x.substring(x.length - 3);
            var otherNumbers = x.substring(0, x.length - 3);
            if (otherNumbers != '')
                lastThree = ',' + lastThree;
            return negative + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
        } }),
    computed: {
        SubscriptionData: function () {
            try {
                return this.$store.getters[Const.GET_SUBSCRIPTION_LIST];
            }
            catch (ex) {
                return {};
            }
        },
        SubscriptionDetail: function () {
            try {
                return this.$store.getters[Const.GET_SUBSCRIPTION_DETAIL];
            }
            catch (ex) {
                return {};
            }
        },
        leadUserListing: function () {
            try {
                return this.$store.getters[Const.GET_LEAD_USER_LISTING];
            }
            catch (ex) {
                return [];
            }
        },
        kycUserListing: function () {
            try {
                return this.$store.getters[Const.GET_KYC_USER_LISTING];
            }
            catch (ex) {
                return [];
            }
        },
        userPanAttemptList: function () {
            try {
                return this.$store.getters[Const.GET_USER_PAN_ATTEMPT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        userListForSquadiq: function () {
            try {
                return this.$store.getters[Const.GET_USER_LIST_FOR_SQUADIQ];
            }
            catch (ex) {
                return [];
            }
        },
        Chartdata: function () {
            try {
                return this.$store.getters[Const.GET_ADMIN_CHART_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        xmlDownload_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_XML_DOWALOAD_DOC_URL];
            }
            catch (ex) {
                return [];
            }
        },
        Depositchart: function () {
            try {
                return this.$store.getters[Const.GET_ADMIN_DEPOSIT_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        Withdrawalchart: function () {
            try {
                return this.$store.getters[Const.GET_ADMIN_WITHDRAWAL_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        Chartlinedata: function () {
            try {
                return this.$store.getters[Const.GET_ADMIN_REGISTRATION_LINE_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        apiKeyData: function () {
            try {
                return this.$store.getters[Const.GET_API_KEY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        adminReferredList: function () {
            try {
                return this.$store.getters[Const.GET_ADMIN_REFERRED_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        //---------------------------------------nominee data----------------------------------------
        NomineeUsersList: function () {
            try {
                return this.$store.getters[Const.GET_USERS_LIST_FOR_NOMINEE];
            }
            catch (ex) {
                return [];
            }
        },
        //-------------------------------------------listing--------------------------------------------
        panData: function () {
            try {
                return this.$store.getters[Const.GET_PAN_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        rolesList: function () {
            try {
                return this.$store.getters[Const.GET_ROLES_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        rising_reconcilation_list: function () {
            try {
                return this.$store.getters[Const.GET_RISING_RECONCILATION_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        debit_list: function () {
            try {
                return this.$store.getters[Const.GET_DEBIT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        get_lock_unlock_data: function () {
            try {
                return this.$store.getters[Const.GET_LOCK_UNLOCK_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        admin_priviledges_assign_list: function () {
            try {
                return this.$store.getters[Const.GET_ADMIN_PRIVILEDGES_ASSIGN_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        stagging_rising_list: function () {
            try {
                return this.$store.getters[Const.GET_STAGGING_RISING_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        stagging_rising_list_csv: function () {
            try {
                return this.$store.getters[Const.GET_STAGGING_RISING_LIST_CSV];
            }
            catch (ex) {
                return [];
            }
        },
        reason_list: function () {
            try {
                return this.$store.getters[Const.GET_REASON_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        step_info_list: function () {
            try {
                return this.$store.getters[Const.GET_STEP_INFORMATION_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        admin_user_list: function () {
            try {
                return this.$store.getters[Const.GET_ADMIN_USER_LISTING];
            }
            catch (ex) {
                return [];
            }
        },
        demat_pending_list: function () {
            try {
                return this.$store.getters[Const.GET_DEMAT_PENDING_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        categorisation_user_list: function () {
            try {
                return this.$store.getters[Const.GET_CATEGORISATION_USER_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        categorisation_user_detail: function () {
            try {
                return this.$store.getters[Const.GET_CATEGORISATION_USER_DETAIL];
            }
            catch (ex) {
                return [];
            }
        },
        admin_view_user_detail: function () {
            try {
                return this.$store.getters[Const.GET_VIEW_ADMIN_USER_DETAIL];
            }
            catch (ex) {
                return [];
            }
        },
        new_reg_view: function () {
            try {
                return this.$store.getters[Const.GET_NEW_REGISTERATIONS];
            }
            catch (ex) {
                return [];
            }
        },
        dashboard_data: function () {
            try {
                var data = this.$store.getters[Const.GET_DASHBOARD_DATA];
                this.registeration_count = data.new_registerations[0].count;
                return this.$store.getters[Const.GET_DASHBOARD_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        nationality_list: function () {
            try {
                return this.$store.getters[Const.GET_NATIONALITY_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        matrial_status_list: function () {
            try {
                return this.$store.getters[Const.GET_MATRIAL_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        income_list: function () {
            try {
                return this.$store.getters[Const.GET_INCOME_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        occupation_list: function () {
            try {
                return this.$store.getters[Const.GET_OCCUPATION_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        cvlResponse: function () {
            try {
                return this.$store.getters[Const.GET_CVL_RESPONSE];
            }
            catch (ex) {
                return [];
            }
        },
        cvlStatus: function () {
            try {
                return this.$store.getters[Const.GET_CVL_STATUS];
            }
            catch (ex) {
                return [];
            }
        },
        get_user: function () {
            try {
                return this.$store.getters[Types.GET_USER];
            }
            catch (ex) {
                return [];
            }
        },
        user_profile: function () {
            try {
                return this.$store.getters[Types.GET_USER];
            }
            catch (ex) {
                return [];
            }
        },
        support_list: function () {
            try {
                return this.$store.getters[Const.GET_SUPPORT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        catList: function () {
            try {
                return this.$store.getters[Const.GET_CAT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        articleList: function () {
            try {
                return this.$store.getters[Const.GET_ARTICLE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        cvlStatusList: function () {
            try {
                return this.$store.getters[Const.GET_CVL_STATUS_LIST];
            }
            catch (ex) {
                return { records: [], total: 0 };
            }
        },
        cvlResponseList: function () {
            try {
                return this.$store.getters[Const.GET_CVL_RESPONSE_LIST];
            }
            catch (ex) {
                return { records: [], total: 0 };
            }
        },
        //-------------------------------------------view----------------------------------------------
        support_view: function () {
            try {
                return this.$store.getters[Const.GET_SUPPORT_VIEW];
            }
            catch (ex) {
                return [];
            }
        },
        get_ticket_docs: function () {
            try {
                return this.$store.getters[Const.GET_SUPPORT_DOCS];
            }
            catch (ex) {
                return [];
            }
        },
        //-------------------------------------------dropdown--------------------------------------------
        support_reason_list: function () {
            try {
                return this.$store.getters[Const.GET_SUPPORT_REASON_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        bank_list: function () {
            try {
                return this.$store.getters[Const.GET_BANK_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        account_type_list: function () {
            try {
                return this.$store.getters[Const.GET_ACCOUNT_TYPE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        state_list: function () {
            try {
                return this.$store.getters[Const.GET_STATE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        city_list: function () {
            try {
                return this.$store.getters[Const.GET_CITY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        country_list: function () {
            try {
                return this.$store.getters[Const.GET_COUNTRY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        segment_list: function () {
            try {
                return this.$store.getters[Const.GET_SEGMENT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        hold_reason_list: function () {
            try {
                return this.$store.getters[Const.GET_HOLD_REASON_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        resident_list: function () {
            try {
                return this.$store.getters[Const.GET_RESIDENT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        gender_list: function () {
            try {
                return this.$store.getters[Const.GET_GENDER_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        address_proof_list: function () {
            try {
                return this.$store.getters[Const.GET_ADDRESS_PROOF_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        address_type_list: function () {
            try {
                return this.$store.getters[Const.GET_ADDRESS_TYPE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        //-------------------------------------------document Url--------------------------------------------
        image_path: function () {
            try {
                return this.$store.getters[Const.GET_USER_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        cvl_doc_path: function () {
            try {
                return this.$store.getters[Const.GET_CVL_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        ticket_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_TICKET_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        pdf_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_PDF_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        NomineeDetail: function () {
            try {
                return this.$store.getters[Const.GET_NOMINEE_DETAIL];
            }
            catch (ex) {
                return [];
            }
        },
        tax_report: function () {
            try {
                return this.$store.getters[Const.GET_TAX_REPORT_LIST1];
            }
            catch (ex) {
                return [];
            }
        },
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/prism_admin/index.ts
// module id = null
// module chunks = 